import {ReactNode} from 'react';
import styled, {css} from 'styled-components';

export interface IButtonProps {
  children: ReactNode;
  // brandOutline?: boolean;
  // primary?: boolean;
  // primaryOutline?: boolean;
  // secondary?: boolean;
}

const buttonDefaultStyles = css`
  display: flex;
  cursor: pointer;
  justify-content: center;
`;

export const BrandOutlineButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goWhite.base};
  color: ${props.theme.colors.goBrandOrange.base};
  border: 1px solid ${props.theme.colors.goBrandOrange.base};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
`,
);

export const PrimaryButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goBrandBlue.base};
  color: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.base};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const SecondaryButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  height: 42px;
  background-color: ${props.theme.colors.goWhite.base};
  
  border: none;
  font-weight: bold;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const PrimaryOutlineButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goWhite.base};
  color: ${props.theme.colors.goBrandBlue.base};
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.base};
  border: 1px solid ${props.theme.colors.goBrandBlue.base};
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const Button = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goBrandOrange.base};
  color: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.large} ${props.theme.spacing.large};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
  margin:0 ${props.theme.spacing.base};
`,
);

export default Button;
